import type { Swiper as SwiperType } from 'swiper'

export const getLeftEdgeSlideIndex = (swiper?: SwiperType): number => {
	if (!swiper || !swiper.slidesGrid || !swiper.slidesSizesGrid) return 0

	const translate = -swiper.translate

	for (let i = 0; i < swiper.slidesGrid.length; i++) {
		const left = swiper.slidesGrid[i]
		const width = swiper.slidesSizesGrid[i]

		if (left === undefined || width === undefined) continue

		const right = left + width

		if (right > translate) return i
	}

	return swiper.slidesGrid.length - 1
}
